// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1CPaj","signatureBlock":"Footer_signatureBlock__28Hpu","signature":"Footer_signature__1CP6e"};